module.exports = __webpack_public_path__ + "img/Picante1.bc7a36f8.png";